import React, { Component } from "react";

class LifeAccident extends Component {
  state = {
    isRegistered: false,
    savedRegistration: [],
    shares: {}, // { [relationID]: percent }
    errorMessage: "",
    showConfirmModal: false,
  };
  componentDidMount() {
    this.props.getAllUserRelation();
    this.props.getUserInsRequest(5);
  }
  componentDidUpdate(prevProps) {
    console.log("userInsRequestJson:", this.props.userInsRequestJson);
    console.log("prev:", prevProps.userInsRequestJson);

    if (
      this.props.userInsRequestJson !== prevProps.userInsRequestJson &&
      this.props.userInsRequestJson &&
      this.props.userInsRequestJson.length > 0
    ) {
      this.loadSavedRegistration(this.props.userInsRequestJson);
    }
    else if (
      this.props.userRelationsJson !== prevProps.userRelationsJson &&
      this.props.userRelationsJson &&
      this.props.userRelationsJson.length > 0 &&
      !this.state.isRegistered &&
      Object.keys(this.state.shares).length === 0
    ) {
      const initialShares = {};
      this.props.userRelationsJson
        .filter((x) => x.NeedEdit !== true)
        .forEach((e) => {
          initialShares[e.ID] = 0;
        });
      this.setState({ shares: initialShares });
    }
  }
  loadSavedRegistration = (requestJson) => {
    const allMembers = requestJson.flatMap(
      (req) =>
        (req.data_addition || []).map((item) => ({
          ID_Relation: item.Relation_ID,
          F_Name: item.F_Name,
          L_Name: item.L_Name,
          Relation_Title: item.Relation_Title,
          National_Code: item.National_Code,
          Percent: item.Percent,
        }))
    );

    const uniqueMembers = Object.values(
      allMembers.reduce((acc, m) => {
        acc[m.ID_Relation] = m;
        return acc;
      }, {})
    );

    this.setState({
      isRegistered: true,
      savedRegistration: uniqueMembers,
    });
  };

  openConfirmModal = () => {
    const total = this.getTotalShare();
    const hasAtLeastOne = Object.values(this.state.shares).some((v) => v > 0);

    if (!hasAtLeastOne) {
      const msg = "حداقل به یکی از اعضای خانوار باید درصد سهم تعلق بگیرد.";
      this.setState({ errorMessage: msg });
      this.props.toggleErrorMessage(msg);
      this.props.toggleError();
      return;
    }

    if (total !== 100) {
      const msg = `مجموع درصد سهم باید دقیقاً ۱۰۰ باشد. مجموع فعلی: ${total}`;
      this.setState({ errorMessage: msg });
      this.props.toggleErrorMessage(msg);
      this.props.toggleError();
      return;
    }

    this.setState({ showConfirmModal: true, errorMessage: "" });
  };


  setSharePercent = (relationId, value) => {
    let percent = parseInt(value, 10);
    if (isNaN(percent) || percent < 0) percent = 0;
    if (percent > 100) percent = 100;

    this.setState((prev) => ({
      shares: { ...prev.shares, [relationId]: percent },
      errorMessage: "",
    }));
  };

  getTotalShare = () => {
    return Object.values(this.state.shares).reduce(
      (sum, v) => sum + (v || 0),
      0
    );
  };

  submitLifeInsuranceForm = () => {
    const token = localStorage.getItem("token");
    if (token === null) {
      const msg = "مجدد وارد سامانه شوید، نشست شما به پایان رسیده است.";
      this.props.toggleErrorMessage(msg);
      this.props.toggleError();
      return;
    }

    const selectedMembers = Object.entries(this.state.shares)
      .filter(([_, percent]) => percent > 0)
      .map(([id, percent]) => ({ ID_Relation: id, Percent: percent }));

    var formdata = new FormData();
    formdata.append("token", token);
    formdata.append("tarhRef", 5);
    formdata.append("ID_Relation", JSON.stringify(selectedMembers));

    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_API_URL}/api/user/submit-insurance-accident`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        if (result !== null) {
          var myObject = JSON.parse(result);
          if (myObject.status === 0) {
            const savedRegistration = this.props.userRelationsJson
              .filter((e) => (this.state.shares[e.ID] || 0) > 0)
              .map((e) => ({
                ID_Relation: e.ID,
                F_Name: e.F_Name,
                L_Name: e.L_Name,
                Relation_Title: e.Relation_Title,
                National_Code: e.National_Code,
                Percent: this.state.shares[e.ID],
              }));

            this.setState({
              showConfirmModal: false,
              isRegistered: true,
              savedRegistration,
            });

            this.props.toggleErrorMessage(myObject.message);
            this.props.toggleError();
          } else {
            // ===== خطا از سمت سرور =====
            this.props.toggleErrorMessage(myObject.message);
            this.props.toggleError();
          }
        }
      })
      .catch((error) => console.log("error", error));
  };


  render() {
    // اگر ثبت‌نام قبلی دارد → نمایش
    if (this.state.isRegistered) {
      return this.renderSavedView();
    }
    return this.renderForm();   // فقط یک مرحله
  }

  renderSavedView() {
    const { savedRegistration } = this.state;
    return (
      <div className="w-100 body-padding">
        <p className="wp-header">بیمه عمر و حوادث کارکنان</p>

        <div className="alert alert-success">
          شما قبلاً در این طرح ثبت‌نام کرده‌اید.
        </div>

        <ul className="Array p-0 mb-5">
          {savedRegistration.length === 0 ? (
            <li className="Array-item">
              <div className="title">اطلاعاتی برای نمایش وجود ندارد.</div>
            </li>
          ) : (
            savedRegistration.map((s) => (
              <li key={s.ID_Relation} className="Array-item readClass">
                <span className="bg-primary text-white wp-text-small rounded p-1">
                  نسبت: {s.Relation_Title}
                </span>
                <div className="title text-dark mt-1">
                  <strong>
                    {s.F_Name} {s.L_Name}
                  </strong>
                </div>
                <div className="describe">
                  کدملی: <b>{s.National_Code}</b>
                </div>
                <div className="describe">
                  درصد سهم: <b>{s.Percent}%</b>
                </div>
              </li>
            ))
          )}
        </ul>
      </div>
    );
  }
  renderForm() {
    const members = this.props.userRelationsJson.filter(
      (x) => x.NeedEdit !== true
    );
    const total = this.getTotalShare();
    const selectedMembers = members.filter(
      (e) => (this.state.shares[e.ID] || 0) > 0
    );

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="item body-padding">
            <p className="wp-header">توزیع درصد سهم بیمه عمر و حوادث</p>

            <div className="alert alert-info text-justify">
              مجموع درصد سهم اعضای خانوار باید دقیقاً <b>۱۰۰</b> باشد.
              درصد سهم هر عضو مشخص نمایید.
            </div>

            {this.state.errorMessage && (
              <div className="alert alert-danger">
                {this.state.errorMessage}
              </div>
            )}

            <ul className="Array p-0 mb-2">
              {members.length === 0 ? (
                <li className="Array-item">
                  <div className="title">
                    اعضای خانوار شما در سیستم ثبت نشده است.
                  </div>
                </li>
              ) : (
                members.map((e) => (
                  <li key={e.ID} className="Array-item readClass">
                    <span className="bg-primary text-white wp-text-small rounded p-1">
                      نسبت: {e.Relation_Title}
                    </span>
                    <div className="title text-dark mt-1">
                      <strong>
                        {e.F_Name} {e.L_Name}
                      </strong>
                    </div>
                    <div className="describe">
                      کدملی: <b>{e.National_Code}</b>
                    </div>
                    <div className="row mt-2 align-items-center">
                      <label className="col-4 col-md-3">درصد سهم:</label>
                      <div className="col-8 col-md-4">
                        <input
                          type="number"
                          min="0"
                          max="100"
                          className="form-control"
                          value={this.state.shares[e.ID] || ""}
                          onChange={(ev) =>
                            this.setSharePercent(e.ID, ev.target.value)
                          }
                          placeholder="0"
                        />
                      </div>
                    </div>
                  </li>
                ))
              )}
            </ul>

            <div className="alert alert-secondary text-center">
              مجموع فعلی: <b>{total}%</b>
              {total === 100 ? <span className="bg-success rounded-pill text-white px-1 small mr-2">آماده ارسال</span> : <span className="bg-danger rounded-pill text-white px-1 small mr-2">خطا در تعیین درصد</span>}
            </div>

            <div className="text-left">
              <button
                onClick={this.props.toggleLifeAccident}
                className="btn btn-danger"
              >
                انصراف
              </button>
              <button
                onClick={this.openConfirmModal}
                className="btn btn-success mr-2"
              >
                ثبت نهایی درخواست
              </button>
            </div>
          </div>
        </div>

        {/* ===== مودال تایید ===== */}
        {this.state.showConfirmModal && (
          <div
            className="modal d-block"
            style={{ background: "rgba(0,0,0,0.5)" }}
            tabIndex="-1"
          >
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    تایید نهایی بیمه عمر و حوادث
                  </h5>
                </div>
                <div className="modal-body">
                  <p className="text-justify">
                    لطفاً قبل از ثبت نهایی، لیست زیر را بررسی کنید:
                  </p>
                  <ul className="list-group">
                    {selectedMembers.map((e) => (
                      <li
                        key={e.ID}
                        className="list-group-item list-group-item-success text-right"
                      >
                        <b>
                          {e.F_Name} {e.L_Name}
                        </b>{" "}
                        — {e.Relation_Title} — <b>{this.state.shares[e.ID]}%</b>
                      </li>
                    ))}
                  </ul>
                  <div className="alert alert-warning mb-0 mt-3">
                    آیا از انتخاب خود اطمینان دارید؟
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() =>
                      this.setState({ showConfirmModal: false })
                    }
                  >
                    بازگشت و اصلاح
                  </button>
                  <button
                    className="btn btn-success"
                    onClick={this.submitLifeInsuranceForm}
                  >
                    بله، مطمئنم و ثبت کن
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
export default LifeAccident;